<template>
  <div class="row">
    <div class="col">
      <div class="form-group">
        <label>Radius %</label>
        <input
          v-model.number="input.radius" 
          type="number"
          step="1"
          class="form-control"
          @input="onInput"
        >
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <label>Left %</label>
        <input
          v-model.number="input.x_center"
          type="number"
          step="1"
          class="form-control"
          @input="onInput"
        >
      </div>
    </div>
    <div class="col">
      <div class="form-group">
        <label>Top %</label>
        <input
          v-model.number="input.y_center"
          type="number"
          step="1"
          class="form-control"
          @input="onInput"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { TYPE_MASK, DEFAULT_OBJECT_MASKS } from '@frontend/group/modules/mask-settings';
import { transformObjectDataToPercent, transformObjectDataToInteger } from '@frontend/group/modules/mask-settings/helpers';

export default {
  props: {
    objectData: {
        type: Object,
        default: () => transformObjectDataToPercent(
          DEFAULT_OBJECT_MASKS()[TYPE_MASK.CIRCLE]
        )
    }
  },
  data() {
    return {
      input: {
        ...transformObjectDataToPercent(
          DEFAULT_OBJECT_MASKS()[TYPE_MASK.CIRCLE]
        )
      }
    }
  },
  watch: {
    objectData() {
      this.input = transformObjectDataToPercent({ ...this.objectData });
    }
  },
  methods: {
    onInput() {
      this.$emit('input', {
        typeMask: TYPE_MASK.CIRCLE,
        objectData: transformObjectDataToInteger({ ...this.input })
      });
    }
  }
}
</script>